import type { EntityCtx } from '@cli-types/next-adapter/generators.js'
import { buildAuthorshipAliasBlock } from '@next-adapter/generators/actions/action-helpers/build-authorship-alias-block.js'
import { renderExclusiveDateUpperBoundHelper } from '@next-adapter/templates/renderers/generators/actions/date-range/exclusive-date-upper-bound-helper.js'
import { renderGenGetPluralContentServerActionTemplate } from '@next-adapter/templates/renderers/generators/actions/entity-file-contents/gen-get-plural-content.js'

export function genGetPluralContent(ctx: EntityCtx): string {
  const dbImports = [ctx.tableVar, 'user', ...ctx.relTableImports].sort()
  const drizzle: string[] = ['asc', 'desc']
  const hasDateRangeFilters = ctx.filters.some((filter) => filter.type === 'date-range')
  if (ctx.hasSearch || ctx.filterableFields.length > 1) drizzle.push('and')
  if (ctx.hasSearch) drizzle.push('ilike', 'or')
  if (ctx.filterableFields.some(() => true)) drizzle.push('eq')
  if (hasDateRangeFilters) drizzle.push('gte', 'lt')
  drizzle.push('sql')
  if (ctx.hasRelationships) drizzle.push('eq')
  const sortedDrizzle = [...new Set(drizzle)].sort()

  const typeImports = [`${ctx.Plural}Page`, `${ctx.Plural}Query`, `${ctx.Singular}`]
  const helperImports: string[] = ['formatActionDate']
  if (ctx.hasSelectFields) helperImports.push(`resolve${ctx.Singular}SelectFields`)
  if (ctx.hasListRels) helperImports.push(`populate${ctx.Singular}ListRelationships`)
  if (ctx.hasMediaFields) helperImports.push(`resolve${ctx.Singular}MediaFields`)
  const populateImport =
    helperImports.length > 0 ? `\nimport { ${helperImports.join(', ')} } from './helpers'` : ''
  const dateRangeHelper = hasDateRangeFilters ? `\n\n${renderExclusiveDateUpperBoundHelper()}` : ''

  const sortableColumns = ctx.sortableColumns ?? []
  const columnMapEntries = sortableColumns
    .map((col: string) => `    '${col}': ${ctx.tableVar}.${col}`)
    .join(',\n')

  return renderGenGetPluralContentServerActionTemplate({
    join: dbImports.join(', '),
    joinText: sortedDrizzle.join(', '),
    ctxCacheReadImport: ctx.cacheReadImport,
    ctxCamelPlural: ctx.camelPlural,
    sort: typeImports.sort().join(', '),
    populateImport: populateImport,
    dateRangeHelper: dateRangeHelper,
    authorshipAliasBlock: buildAuthorshipAliasBlock(),
    columnMapEntries: columnMapEntries,
    ctxPlural: ctx.Plural,
    ctxCacheLifeLine: ctx.cacheLifeLine,
    ctxSearchBlock: ctx.searchBlock,
    ctxFilterConditions: ctx.filterConditions,
    ctxListSelectClause: ctx.listSelectClause,
    ctxTableVar: ctx.tableVar,
    ctxWhere:
      ctx.hasSearch || ctx.filterableFields.length > 0
        ? '.where(conditions.length > 0 ? and(...conditions) : undefined)'
        : '',
    ctxListResultMapping: ctx.listResultMapping,
    ctxPluralText: ctx.plural
  })
}
